export const onCreateTaskListUnit = `
    subscription OnCreateTaskListUnit(
        $workspaceId: ModelSubscriptionIDInput!
    ) {
        onCreateTaskListUnit(workspaceId: $workspaceId) {
            id
            ownerId
            workspaceId
            name
            description
            avatarPath
            isArchived
            taskLists
            taskListsOrder
            logicalDayShift
            timezone
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const onUpdateTaskListUnit = `
    subscription OnUpdateTaskListUnit(
        $workspaceId: ModelSubscriptionIDInput!
    ) {
        onUpdateTaskListUnit(workspaceId: $workspaceId) {
            id
            ownerId
            workspaceId
            name
            description
            avatarPath
            isArchived
            taskLists
            taskListsOrder
            logicalDayShift
            timezone
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const onDeleteTaskListUnit = `
    subscription OnDeleteTaskListUnit(
        $workspaceId: ModelSubscriptionIDInput!
    ) {
        onDeleteTaskListUnit(workspaceId: $workspaceId) {
            id
            ownerId
            workspaceId
            name
            description
            avatarPath
            isArchived
            taskLists
            taskListsOrder
            logicalDayShift
            timezone
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const onCreateTask = `
    subscription OnCreateTask($taskListUnitId: ModelSubscriptionIDInput!) {
        onCreateTask(taskListUnitId: $taskListUnitId) {
            id
            taskListUnitId
            taskListId
            name
            description
            scheduleRule
            relatedPage
            config
            images
            isArchived
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const onUpdateTask = `
    subscription OnUpdateTask($taskListUnitId: ModelSubscriptionIDInput!) {
        onUpdateTask(taskListUnitId: $taskListUnitId) {
            id
            taskListUnitId
            taskListId
            name
            description
            scheduleRule
            relatedPage
            config
            images
            isArchived
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const onDeleteTask = `
    subscription OnDeleteTask($taskListUnitId: ModelSubscriptionIDInput!) {
        onDeleteTask(taskListUnitId: $taskListUnitId) {
            id
            taskListUnitId
            taskListId
            name
            description
            scheduleRule
            relatedPage
            config
            images
            isArchived
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const onCreateTaskReport = `
    subscription OnCreateTaskReport($taskListUnitId: ModelSubscriptionIDInput!) {
        onCreateTaskReport(taskListUnitId: $taskListUnitId) {
            id
            taskId
            taskListUnitId
            completedAt
            status
            comment
            images
            commentImages
            completedBy
            logicalDayStart
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const onUpdateTaskReport = `
    subscription OnUpdateTaskReport($taskListUnitId: ModelSubscriptionIDInput!) {
        onUpdateTaskReport(taskListUnitId: $taskListUnitId) {
            id
            taskId
            taskListUnitId
            completedAt
            status
            comment
            images
            commentImages
            completedBy
            logicalDayStart
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;

export const onDeleteTaskReport = `
    subscription OnDeleteTaskReport($taskListUnitId: ModelSubscriptionIDInput!) {
        onDeleteTaskReport(taskListUnitId: $taskListUnitId) {
            id
            taskId
            taskListUnitId
            completedAt
            status
            comment
            images
            commentImages
            completedBy
            logicalDayStart
            version
            createdAt
            updatedAt
            createdBy
            updatedBy
        }
    }
`;
